import Landing from '../pages/Landing'
import WhyHygen from '../pages/WhyHygen';
import Organization from '../pages/Organization';
import Electrolysers from '../pages/Electrolysers';
import PVElectrolyser from '../pages/PVElectrolyser';
import Worldwide from '../pages/Worldwide';
import SingleBlog from '../pages/SingleBlog';


const routeConfig = [
  {
    path: '/',
    element: <Landing />,
  },
  {
    path: '/hydrogen',
    element: <WhyHygen />,
  },
  {
    path: '/technology/green-molecules-electrolysers',
    element: <Electrolysers />,
  },
  {
    path: '/technology/pv-electrolyser-modules',
    element: <PVElectrolyser />,
  },
  // {
  //   path: '/worldwide',
  //   element: <Worldwide />,
  // },
  // {
  //   path: '/worldwide/blog',
  //   element: <SingleBlog />,
  // },
  {
    path: '/organization',
    element: <Organization />,
  },
]
export default routeConfig